/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Employeeonkpf4Inputs */

const de__field_employeeonkpf4 = /** @type {(inputs: _Field_Employeeonkpf4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitarbeiter auf KPF`)
};

/**

* @param {_Field_Employeeonkpf4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_employeeonkpf4 = /** @type {((inputs?: _Field_Employeeonkpf4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Employeeonkpf4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_employeeonkpf4(inputs)
});
export { _field_employeeonkpf4 as "_field_employeeOnKPF" }